document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-location-toggle]');
  const button = toggle.querySelector('.location-button');
  const dropdown = toggle.querySelector('.location-dropdown');

  button.addEventListener('click', () => {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', !expanded);
    dropdown.hidden = expanded;
  });

  document.addEventListener('click', (e) => {
    if (!toggle.contains(e.target)) {
      button.setAttribute('aria-expanded', 'false');
      dropdown.hidden = true;
    }
  });
});